import { Box, Container } from '@mui/material';
import React from 'react';

import { LoanExampleText } from '@/components/LoanExampleText/index.ts';

export type DisclaimerProps = {
  // Empty
};

export const Disclaimer: React.FC<DisclaimerProps> = () => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.contrast,
        py: 2,
      }}
    >
      <Container maxWidth="md">
        <div className="text-center typography-v1-body4 text-balance text-white">
          <LoanExampleText />
        </div>
      </Container>
    </Box>
  );
};
